<template>
  <Layout>
    <div slot="content">
      <div class="row">
        <div class="col-xl-6">
          <div class="table-responsive card p-6">
            <div class="card-header border-0 p-0">
              <div class="card-title">
                <div class="d-flex align-items-center"><b v-text="$t('그룹')" /></div>
              </div>
              <div class="card-toolbar">
                <div class="d-flex justify-content-end">
                  <button class="btn btn-primary" @click="sel = {}; mode = '그룹 추가'; $bvModal.show('그룹')" v-text="$t('그룹 추가')" />
                </div>
              </div>
            </div>
            <TreeView2 size="lg" :treeData="grpTree" labelKey="grpNm" @clicked="selUsers" minHeight="495px" :customAction="treeActions"></TreeView2>
          </div>
        </div>
        <div class="col-xl-6">
          <TableView @action="subAction" :actions="['삭제']" :title="sel.grpNm || ''" :columns="cols" :list="list" min-width="auto" minHeight="450px">
            <div class="d-flex align-items-center position-relative">
              <b-icon icon="search" />
              <input @keydown.enter="prevent" @change="searchKeyword = $event.target.value;" class="form-control form-control-solid w-300px ps-11" 
                :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')" />
              <button :disabled="!sel.grpId" class="ms-3 btn btn-primary" @click="subAction({ action: '배정' })"
                v-text="$t('멤버 배정')" />
            </div>
          </TableView>
        </div>
      </div>
    </div>
    
    <ModalForm @action="action" :title="'그룹 ' + (mode == '수정' ? '수정' : '추가')" id="그룹" centered
      :data="mode == '수정' ? sel : {}" :spec="grpCols" label-cols="3" :ok-title="$t(mode)">
      <div v-if="mode == '수정'" class="text-right mb-3"><button class="btn btn-sm btn-danger"
          @click="action({ action: '삭제' })" v-text="$t('삭제')" /></div>
      <div v-else class="mb-3 gray-txt" v-html="`${this.$t('대상그룹')}: ${sel.grpNm || '최상위에 추가'}`" />
    </ModalForm>
    <b-modal id="배정" :title="$t('멤버 배정')" dialog-class="min-w-1024px" body-class="p-5 pt-3" hide-footer>
      <div class="d-flex flex-column">
          <div class="d-flex justify-content-between mb-2">
            <div class="d-flex justify-content-end">
              <div class="d-flex align-items-center position-relative">
                <b-icon icon="search" />
                <input type="text" v-model="partiParams.searchKeyword" class="form-control form-control-solid form-control ps-11 pe-12 w-500px border-def" maxlength="100"
                  :placeholder="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                  :title="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                  @keydown="onTyping = true" 
                  @keyup.enter="searchPartiMemberList">
                <a v-if="partiParams.searchKeyword" @click="removeSearchPartiMember"
                  class="icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary position-absolute end-0 me-1">
                  <i class="bi bi-x-circle fs-3"></i>
                </a>
              </div>
              <a class="btn btn-secondary ms-1" :class="{'d-none': !partiSearchMode}" @click="removeSearchPartiMember">
                <i class="bi bi-arrow-left-short"></i>{{ $t('조직도') }}
              </a>
            </div>
            <b-button v-if="!unmaskKey && (allPartiMemberList.length || partiMemberList.length)" class="btn-sm" @click="reqUnmask()" variant="warning">
              {{ $t('마스킹 해제') }}
            </b-button>
          </div>
          <div style="height: 64vh;" class="row">
            <div class="h-100 d-flex" :class="{'d-none': partiSearchMode}">
              <div class="h-100" style="width: 38%;">
                <TreeView2 ref="partiSelTree" size="lg" :treeData="partiSelTree" @clicked="choicePartiGrp" height="100%"
                  :filterHolder="$t('조직명, 그룹명')" showOuterBorder></TreeView2>
              </div>
              <div class="h-100 ms-4" style="width: 62%;">
                <div class="ps-2" style="height: 30px;">
                  <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
                </div>
                <div style="height: calc(100% - 30px)">
                  <TableView ref="partiMemberTable" class="table-break-all" :list="partiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                    min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                    :columns="[
                      { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                      { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                    ]">
                  </TableView>
                </div>
              </div>
            </div>
            <div class="h-100" style="width: 100%;" :class="{'d-none': !partiSearchMode}">
              <div class="ps-2" style="height: 30px;">
                <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
              </div>
              <div style="height: calc(100% - 30px)">
                <TableView ref="allPartiMemberTable" class="table-break-all" :list="allPartiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                  min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                  :columns="[
                    { key: 'custAbbr', label: 'Cust Abbr.', style: { textAlign: 'center' } },
                    { key: 'custName', label: '조직명', style: { textAlign: 'center' } },
                    { key: 'custFullName', label: '조직영문명', style: { textAlign: 'center' } },
                    { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                    { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                    { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                  ]">
                </TableView>
              </div>
            </div>
          </div>
        </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import TreeView2 from "@/components/TreeView2.vue";
import ModalForm from "@/components/ModalForm.vue";

export default {
  components: { Layout, TableView, TreeView2, ModalForm },
  data: () => ({
    sel: {}, searchKeyword: '', list: [], grpTree: [], mode: '',
    partiSelTree: '', unmaskKey: '', onTyping: false, partiSearchMode: false,
    partiMemberList: [], allPartiMemberList: [], partiParams: { selType: '', selKey: '', searchKeyword: '' }, 
    grpCols: [
      { required: true, key: 'grpNm', label: '그룹명', form: 1, style: { textAlign: 'center' } },
      { key: 'description', label: '설명', form: 2, type: 'textarea' },
    ],
    cols: [
      { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
      { key: 'roleNms', label: '권한명', style: { textAlign: 'center' } },
      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
    ],
  }),
  async created() { this.getGrpTree() },
  mounted() {
    this.$reduceScreen();
  },
  computed: {},
  watch: { orgChartKeyword(q) { this.$treeKeywordChange(q, '배정') } },
  methods: {
    async subAction({ item, action }) {
      if (action == 'view') return;
      if (action == '배정') {
        this.openPartiSelTree();
        return;
      }
      if (!(await this.$alert(this.$t('[$] 배정 삭제 하시겠습니까?', [item.userNm]), { title: this.sel.grpNm, confirm: true }))) return;
      const res = await this.$api('main/grp/deleteGrpMember', { userId: item.userId });
      if (res.success) this.getList();
      else this.$alert(res.msg);
    },
    async action({ action, form }) {      
      let res;
      if (!form) {
        this.$bvModal.hide('그룹');
        if (!(await this.$alert(this.$t('[$] 그룹을 $ 하시겠습니까?', [this.sel.grpNm, action]), { confirm: true }))) return;
        res = await this.$api('main/grp/' + ({ 삭제: 'deleteGrp' })[action], { grpId: this.sel.grpId });
      }
      else if (this.mode == '수정') {
        form.grpId = this.sel.grpId;
        res = await this.$api('main/grp/updateGrp', form);
      }
      else if (this.mode == '그룹 추가') {
        form.pGrpId = this.sel.grpId || '';
        res = await this.$api('main/grp/insertGrp', form);
      }
      await this.$alert(res.msg);
      if (res.success) this.getGrpTree();
    },
    async getList() {
      this.list = [];
      this.list = (await this.$api('main/grp/selectGrpUserList', { grpId: this.sel.grpId, searchKeyword: this.searchKeyword || null })).list;
    },
    async selUsers({ item, action }) {      
      this.searchKeyword = '';
      this.sel = item;
      if (['그룹 추가', '수정'].includes(action)) {
        this.mode = action;
        if (action == '수정') Object.assign(this.sel, (await this.$api('main/grp/selectGrp', { grpId: this.sel.grpId })).data);
        this.$bvModal.show('그룹');
      }
      this.getList();
    },
    treeActions() {
      return `
          <span class="btn btn-xs btn-light-primary me-2" action="그룹 추가">${this.$t('그룹 추가')}</span>
          <span class="btn btn-xs btn-light-primary" action="수정">${this.$t('수정')}</span>
      `;
    },
    async prevent(event) {
      event.preventDefault();
      this.searchKeyword = event.target.value;
      this.list = (await this.$api('main/grp/selectGrpUserList', { grpId: this.sel.grpId, searchKeyword: this.searchKeyword || null })).list;
    },
    async getGrpTree() {
      this.grpTree = [];
      this.sel = {};      
      const { list } = await this.$api('main/grp/selectGrpList', {});
      for (const dir of list) {
        if (dir.pGrpId > 0) list.find(d => d.grpId == dir.pGrpId).children.push(Object.assign(dir, { children: [] }));
        else this.grpTree.push(Object.assign(dir, { children: [] }));
      }

      this.$nextTick(() => {
        this.list = [];
      });
    },
    async openPartiSelTree() {
      // 매번 초기화
      let custItems = [];
      const custList = (await this.$api('main/grp/selectPartiGrpList', {})).list;
      custList.forEach((cust) => {
        let custItem = Object.assign(cust, {icon: 'bi-building-fill', type: 'cust', key: cust.custId, label: cust.custName, children: []});
        custItem.children.push({icon: 'bi-person-exclamation', type: 'grp', key: '-1', label: '미분류'});
        custItems.push(custItem);
        for(const grp of cust.grpList) {
          let currItem = grp.pGrpId == 0 ? custItem : cust.grpList.find(d => d.grpId == grp.pGrpId)
          currItem.children.push(Object.assign(grp, {icon: 'bi-people-fill', type: 'grp', key: grp.grpId, label: grp.grpNm, children: []}));
        }
      });

      this.partiSelTree = [...custItems];
      this.partiParams = { selType: '', selKey: '', searchKeyword: '' };
      this.partiSearchMode = false;
      
      // 참여자 목록 초기화
      this.$nextTick(() => {
        this.partiMemberList = [];
        this.allPartiMemberList = [];
        this.$refs.partiSelTree.selectItem('-1', 'grp');
      });
      
      this.$bvModal.show('배정');
    },
    async choicePartiGrp({item} = {}) {
      this.onTyping = false;
      this.partiParams.selType = item.type;
      this.partiParams.selKey = item.key;
      this.partiParams.searchKeyword = '';
      this.unmaskKey = '';
      this.selectPartiMemberList(item.type == 'cust' ? {selCustId: item.key} : {selGrpId: item.key});
    },
    async searchPartiMemberList() {
      if(this.partiParams.searchKeyword) {
        this.onTyping = false;
        this.unmaskKey = '';
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword});
      }
    },
    async removeSearchPartiMember() {
      this.partiParams.searchKeyword = '';
      this.partiSearchMode = false;
      this.unmaskKey = '';
    },
    async reqUnmask() {
      const { success, msg, data } = await this.$api('cmm/unmask', { unmaskActCd: 'GRP_SRC_MEMBER' });
      if (!success) return this.$alert(msg);
      this.unmaskKey = data.unmaskKey;
      if(this.partiSearchMode) {
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword, unmaskKey: this.unmaskKey});
      } else {
        let params = this.partiParams.selType == 'cust' ? {selCustId: this.partiParams.selKey} : {selGrpId: this.partiParams.selKey};
        params.unmaskKey = this.unmaskKey;
        this.selectPartiMemberList(params);
      }
    },
    async selectPartiMemberList(params) {
      if(!this.onTyping) {
        if(this.partiParams.searchKeyword) { // 검색 모드
          this.allPartiMemberList = [];
          const resultList = (await this.$api('main/grp/selectPartiMemberList', params)).list;
          this.allPartiMemberList = [...resultList];
          this.partiSearchMode = true;
        } else {
          this.partiMemberList = [];
          const resultList = (await this.$api('main/grp/selectPartiMemberList', params)).list;
          this.partiMemberList = [...resultList];
          this.partiSearchMode = false;
        }
        this.onTyping = false;
      }
    },
    async assignPartiMember({item}) {
      const { grpId } = this.sel;
      const { success, msg } = await this.$api('main/grp/insertGrpMember', { grpId, userId: item.userId });
      this.$bvModal.hide('배정');
      await this.$alert(msg);
      if (success) this.getList();
    },
  },
}
</script>
